import React from 'react';

function ContactInfo({ variant = 'card' }) {
  if (variant === 'banner') {
    return (
      <div className="bg-water-600 text-white py-8 md:py-12">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Ready to Improve Your Pond or Lake?
          </h2>
          <p className="text-lg text-water-100 mb-6 max-w-2xl mx-auto">
            Get a free consultation from Joe. He'll assess your needs and provide expert recommendations.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="tel:+17272773366"
              className="bg-white text-water-700 hover:bg-slate-100 font-bold py-4 px-8 rounded-lg transition-colors duration-200 text-lg min-h-[56px] flex items-center justify-center w-full sm:w-auto shadow-lg"
            >
              <span className="mr-2">📞</span>
              Call Joe: (727) 277-3366
            </a>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-nature-600 hover:bg-nature-700 text-white font-bold py-4 px-8 rounded-lg transition-colors duration-200 text-lg min-h-[56px] flex items-center justify-center w-full sm:w-auto shadow-lg"
            >
              <span className="mr-2">✉️</span>
              Email for Quote
            </a>
          </div>
        </div>
      </div>
    );
  }

  if (variant === 'inline') {
    return (
      <div className="text-center py-6">
        <p className="text-lg text-brand-700 mb-3">Contact Joe for a Free Consultation</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
          <a
            href="tel:+17272773366"
            className="text-water-600 hover:text-water-700 font-semibold text-lg min-h-[44px] flex items-center"
          >
            <span className="mr-2">📞</span>
            (727) 277-3366
          </a>
          <span className="hidden sm:inline text-slate-400">|</span>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="text-water-600 hover:text-water-700 font-semibold text-lg break-all min-h-[44px] flex items-center"
          >
            <span className="mr-2">✉️</span>
            andersponds@gmail.com
          </a>
        </div>
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <div className="flex flex-col sm:flex-row gap-3 justify-center items-center py-4">
        <a
          href="tel:+17272773366"
          className="inline-flex items-center justify-center bg-water-600 hover:bg-water-700 text-white font-bold py-3 px-6 rounded-lg transition-colors min-h-[48px]"
        >
          <span className="mr-2">📞</span>
          Call Joe
        </a>
        <a
          href="#contact"
          onClick={(e) => {
            e.preventDefault();
            document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
          }}
          className="inline-flex items-center justify-center bg-nature-600 hover:bg-nature-700 text-white font-bold py-3 px-6 rounded-lg transition-colors min-h-[48px]"
        >
          <span className="mr-2">✉️</span>
          Email for Quote
        </a>
      </div>
    );
  }

  // Default 'card' variant
  return (
    <div className="bg-white rounded-lg shadow-lg p-6 md:p-8 border-2 border-brand-200">
      <h3 className="text-2xl font-bold text-brand-900 mb-4 text-center">
        Get in Touch
      </h3>
      <div className="space-y-4">
        <div className="text-center">
          <p className="text-slate-600 mb-2">Call Joe</p>
          <a
            href="tel:+17272773366"
            className="block text-2xl font-bold text-water-600 hover:text-water-700 min-h-[44px] flex items-center justify-center"
          >
            (727) 277-3366
          </a>
        </div>
        <div className="border-t border-slate-200 pt-4 text-center">
          <p className="text-slate-600 mb-2">Email</p>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="block text-lg text-water-600 hover:text-water-700 break-all min-h-[44px] flex items-center justify-center"
          >
            andersponds@gmail.com
          </a>
        </div>
        <div className="border-t border-slate-200 pt-4 text-center">
          <p className="text-sm text-slate-500">
            Licensed & Insured
          </p>
          <p className="text-sm text-slate-500">
            Serving Greater Tampa Bay and St. Pete
          </p>
        </div>
      </div>
    </div>
  );
}

export default ContactInfo;
